module.exports = __webpack_public_path__ + "img/panit.045a83ea.png";